import { mergeStyles } from '@bingads-webui-campaign-react/common-styles';

export const getStyles = (theme, palette = {}) => ({
  budgetContainer: {
    ...mergeStyles(
      { theme },
      {
        '& .container-budget': {
          '& span': {
            color: palette.neutralPrimary,
          },
          '& .form-control-static': {
            padding: '9px 0px',
            lineHeight: '14px',
            minHeight: 'auto',
          },
          '& .input-group': {
            marginLeft: 15,
            '& .input-group-addon': {
              color: '#323130',
              border: 0,
              padding: '6px',
              background: '#ffffff',
            },
          },
          '& .col-sm-3': {
            display: 'table',
            paddingRight: 0,
            paddingLeft: 0,
          },
          '& .margin-rt-five': {
            paddingLeft: 28,
          },

        },
        '& span.bold': {
          fontWeight: 1000,
        },
        '& .alert-budget-button': {
          marginLeft: '10px',
          paddingTop: '5px',
          '& button': {
            color: 'black',
            fontSize: '13px',
            fontWeight: 500,
            borderColor: '#edebe9',
          },
        },
      }
    ),
  },
});
